import { render, staticRenderFns } from "./InvestmentInformations.vue?vue&type=template&id=190a0e44&scoped=true&"
import script from "./InvestmentInformations.vue?vue&type=script&lang=js&"
export * from "./InvestmentInformations.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentInformations.vue?vue&type=style&index=0&id=190a0e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a0e44",
  null
  
)

export default component.exports